import getCommonData from '~/lib/tealium/data/common-data';
import getPageData from '~/lib/tealium/data/page-data';
import getEventData from '~/lib/tealium/data/event-data';
import { pageNames } from '~/constants/pageNames';

const getRadioOnChangeTags = (state) => {
  return {
    description: 'Fired on loanReview page when loanAmount radio button is clicked.',
    eventIdentifier: {
      trackingPageName: pageNames.loanReview,
      component: 'Radio',
      name: 'loanAmountIndex',
      type: 'onChange',
    },
    content: piggyEvent => {
      return {
        ...getCommonData(state),
        ...getPageData(piggyEvent.trackingPageName, state),
        ...getEventData(piggyEvent, state),
        funnel_step: '',
      };
    },
  };
};

export default getRadioOnChangeTags;
